const state = {
  popupIsOpen: false,
  popupType: '',
  popupDark: true,
  popupContent: {}
}

const mutations = {
  closePopup (state) {
    state.popupIsOpen = false
  },
  openPopup (state, popup) {
    state.popupContent = popup.content
    state.popupType = popup.type
    state.popupDark = popup.dark
    state.popupIsOpen = true
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
